/**
 * PublicFloatingControls
 *
 * Top-right floating control panel on the public shared map — wraps the shared
 * `PublicControls` pair (language switcher + theme toggle) in a `FloatingPanel`,
 * mirroring the authenticated map's `FloatingNavBar` placement. The same pair is
 * also folded into the detail panel toolbar (see `PublicControls`).
 *
 * @module components/share/public/PublicFloatingControls
 */
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { FloatingPanel } from '@/components/ui/FloatingPanel';
import { PublicControls } from '../PublicControls';

import styles from './PublicFloatingControls.module.css';

export const PublicFloatingControls = memo(function PublicFloatingControls() {
  const { t } = useTranslation();

  return (
    <FloatingPanel
      position="top-right"
      aria-label={t('share.public.controlsLabel')}
    >
      <div className={styles.controls}>
        <PublicControls />
      </div>
    </FloatingPanel>
  );
});
